import React from "react";
import MainPageCompenent from './MainPageCompenent';
import UserProfileForm from "./UserProfileForm";
function UserProfile(props) {
    return (
        <MainPageCompenent>
            <UserProfileForm />
        </MainPageCompenent>
    );
}

export default UserProfile;